module.exports = __webpack_public_path__ + "static/mesh-bg-full-dl-4ba0cf9ddc8a8117444e57ddebc5b9c4.png";